import * as constants from '../constants';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.addOwnerSampleLog.success: {
            return action.payload;
        }

        case constants.addOwnerSampleLog.error:
        case constants.addOwnerSampleLog.try: {
            return initialState;
        }

        default:
            return state;
    }
}